import React from 'react';
import { MonitoredByTypes } from 'store/modules/monitoring_store/types';
import { Container } from './styles';

interface MonitoredByBalloonProps {
  monitoredByList: Array<MonitoredByTypes>;
  tradingPosition: number;
}

const MonitoredByBalloon = (props: MonitoredByBalloonProps) => {
  const { monitoredByList, tradingPosition } = props;

  const compactMonitoredBy = (monitoredByList: Array<MonitoredByTypes>) => {
    if (!monitoredByList) return [''];

    if (monitoredByList?.length === 1) return [monitoredByList[0].acronym_name];
    if (monitoredByList?.length === 2)
      return [monitoredByList[0]?.acronym_name, monitoredByList[1]?.acronym_name];
    return [monitoredByList[0]?.acronym_name, `+${(monitoredByList.length - 1).toString()}`];
  };

  const balloonText = (monitoredByList: Array<MonitoredByTypes>) => {
    if (!monitoredByList) return '';

    let text = 'Monitorado por: ';
    monitoredByList.forEach((monitoredBy, index) => {
      text += monitoredBy.nome.split(' ').slice(0, 2).join(' ');
      if (monitoredByList?.length === 1) return;
      if (index === monitoredByList.length - 2) {
        text += ' e ';
        return;
      }
      if (index === monitoredByList.length - 1) return;
      text += ', ';
    });
    return text;
  };

  const monitors = compactMonitoredBy(monitoredByList);

  return (
    <Container
      className="databalloon"
      aria-label={balloonText(monitoredByList)}
      data-balloon-pos={tradingPosition < 2 ? 'down-right' : 'up-right'}
      data-balloon-length="medium"
      data-balloon-blunt
    >
      <div className="monitoredBy d-flex align-items-center justify-content-center ml-1">
        <i className="material-icons">person</i>
        <span className="mr-1">{monitors?.length}</span>
      </div>
    </Container>
  );
};

export default MonitoredByBalloon;
